import { Component, OnInit } from '@angular/core';
import { ReclamationService } from '../modules/reclamation/services/reclamation.service';
import { UserService } from '../modules/auth/services/user.service';
import { TokenStorageService } from '../modules/auth/services/token-storage.service';
import { User } from '../modules/auth/models/user.model';
import { Router } from '@angular/router';
import { DelaisService } from '../shared/services/delaisdepasse.service';
import { MotifreclamationService } from '../shared/services/motifreclamation';

@Component({
  selector: 'app-tasks',
  templateUrl: './tasks.component.html',
  styleUrls: ['./tasks.component.css']
})
export class TasksComponent implements OnInit {

  totalrectypes=[]
  banque: string;
  totalrecs: any=0;
  totalrecsactif: any;
  totalrecscloture: any;
  reclamationsonusSub: any;
  reclamationsonustotal: number;
  reclamationsemeSub: any;
  reclamationsemetotal: number;
  reclamationsacqSub: any;
  reclamationsacqtotal: number;
  totalrecstotreattotal: any;
  totalrecstotreat: any=[];
  user: User;
  motifsub: any;
  currentdate: number;
  motifs: any
  carte: string;
  constructor(private recserv:ReclamationService,private userserv:UserService, private Auth:TokenStorageService,private router:Router,private delaidepasse:DelaisService,private mot:MotifreclamationService)
  {}
ngOnInit(): void {
  const currentuser = this.Auth.getUser();
  this.motifsub = this.mot.motifreclamations$.subscribe(
    (motifs) => {
      this.motifs=motifs
      motifs[0].currentdate?this.currentdate = motifs[0].currentdate:this.currentdate = new Date().getTime();
    }
  )
this.userserv.getUserById(currentuser.userId).then(
  (response:User) => {
    this.user=response
    this.banque=response.banque
    this.carte=response.carte
//get onus reclamations
this.reclamationsonusSub = this.recserv.reclamationsonus$.subscribe(
  (reclamations) => {
    this.reclamationsonustotal=reclamations.length
    this.totalrectypes.push(
      {
        path: 'assets/img/visa.svg',
        total: this.reclamationsonustotal,
        libelle:'Réclamations ONUS',
        type:'onus'

      }
    )
  },
  (error) => {
  }
);  
//get eme reclamations
this.reclamationsemeSub = this.recserv.reclamationseme$.subscribe(
  (reclamations) => {
    this.reclamationsemetotal=reclamations.length
    this.totalrectypes.push(
      {
        path: 'assets/img/visa.svg',
        total: this.reclamationsemetotal,
        libelle:'Réclamations Emetteur',
        type:'eme'

      }
    )
  },
  (error) => {
  }
);
//get acq reclamations
this.reclamationsacqSub = this.recserv.reclamationsacq$.subscribe(
  (reclamations) => {
    this.reclamationsacqtotal=reclamations.length
    this.totalrectypes.push(
      {
        path: 'assets/img/visa.svg',
        total: this.reclamationsacqtotal,
        libelle:'Réclamations Acquireur',
        type:'acq'


      }
    )
  },
  (error) => {
  }
); 
if(response.usertype=='Metier'&&response.role=='adminbanque')
{
  this.recserv.getReclamationonus(this.banque)
  this.recserv.getReclamationeme(this.banque)
  this.recserv.getReclamationacq(this.banque)
  this.mot.getmotifreclamationss()
  this.recserv.getReclamationallperbanque(this.banque).then(
    (response: any) => {
      this.totalrecs=response.total
    }
  )
  this.recserv.getReclamationtotreat(this.banque).then(
    (response: any) => {
      this.totalrecstotreattotal=response.total
      this.totalrecstotreat=response.data
  
    }
  )
  this.recserv.getReclamationactif(this.banque).then(
    (response: any) => {
      this.totalrecsactif=response.total
    }
  )  
  this.recserv.getReclamationcloture(this.banque).then(
    (response: any) => {
      this.totalrecscloture=response.total
    }
  ) 
}
else if(response.usertype=='comite arbitrage')
{
  this.recserv.getReclamationcomitetotreat(this.banque).then(
    (response: any) => {
      this.totalrecstotreattotal=response.total
      this.totalrecstotreat=response.data
  
    }
  )
}
else if(response.carte)
{
  this.recserv.getReclamationporteurtotreat(this.carte).then(
    (response: any) => {
      this.totalrecstotreattotal=response.total
      this.totalrecstotreat=response.data
  
    }
  )
}
  }

)
}
getNavigation(link, id,rec){
this.delaidepasse.Authorize(this.user,rec,this.currentdate,this.motifs,link)
//  this.router.navigate([link + '/' + id]); 
}
}
